import Vue from 'vue'
import App from './JobsApp.vue'

import MdcTextField from './components/mdc/TextField.vue'
import MdcCard from './components/mdc/Card.vue'
import MdcBody from './components/mdc/Body.vue'
import MdcIcon from './components/mdc/Icon.vue'
import MdcButton from './components/mdc/Button.vue'
import MdcIconButton from './components/mdc/IconButton.vue'
import MdcLayoutGrid from './components/mdc/LayoutGrid.vue'
import MdcLayoutCell from './components/mdc/LayoutCell.vue'
import MdcSelect from './components/mdc/Select.vue'
import MdcSelectItem from './components/mdc/SelectItem.vue'
import MdcTitle from './components/mdc/Title.vue'
import VueCarousel from 'vue-carousel'

Vue.use(VueCarousel)

const components = {
  MdcTextField,
  MdcCard,
  MdcBody,
  MdcIcon,
  MdcButton,
  MdcIconButton,
  MdcLayoutGrid,
  MdcLayoutCell,
  MdcSelect,
  MdcSelectItem,
  MdcTitle
}

Object.entries(components).forEach(([name, component]) => {
  Vue.component(name, component)
})

new Vue({
  render: h => h(App)
}).$mount('#app')
